import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { environment } from '../../../config/environment';
import './DigiLockerVerification.css';
const BASE_URL = `${environment.apiUrl}/digilocker/callback`;
 
const ShieldIcon = () => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11.1L18 7.37V5.37L12 2.6L6 5.37V7.37L12 11.1ZM12 12.8C10.6 12.8 9.27 13.06 8 13.5V11.5L12 10L16 11.5V13.5C14.73 13.06 13.4 12.8 12 12.8ZM12 21.35C8.24 20.21 5 15.93 5 11.23V6.5L12 3.4L19 6.5V11.23C19 15.93 15.76 20.21 12 21.35Z" fill="#3B82F6"/>
        <path d="M12 16.4C10.6 16.4 9.27 16.66 8 17.1V15.1L12 13.6L16 15.1V17.1C14.73 16.66 13.4 16.4 12 16.4Z" fill="#3B82F6"/>
    </svg>
);
 
const InstantAccessIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="#3B82F6"/>
        <path d="M13 7H11V13L16.2 16.2L17 14.9L13 12.5V7Z" fill="#3B82F6"/>
    </svg>
);
 
const SecureTrustedIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10.5 16.5L6 12L7.41 10.59L10.5 13.67L16.59 7.59L18 9L10.5 16.5Z" fill="#22C55E"/>
    </svg>
);
 
const API_URL = 'https://kyc-api.surepass.app/api/v1/digilocker/initialize';
 
const DigiLockerVerification = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
 
    const handleVerifyClick = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        const requestBody = {
            data: {
                signup_flow: true,
                redirect_url: BASE_URL
            }
        };
 
        try {
 
            const response = await fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc1MTA4NzkxNywianRpIjoiOTk0MWMzMGUtNGY4Ny00NTNkLWE0OTEtODNkNmZiNDE0OGEzIiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LnVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsIm5iZiI6MTc1MTA4NzkxNywiZXhwIjoyMzgxODA3OTE3LCJlbWFpbCI6InVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.HJHPVrHRTVD0wwXiiI226F7A7r_fIAjMvVaChKoc6W8`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });
 
            if (!response.ok) {
             
                const errorData = await response.json().catch(() => ({}));
                const errorMessage = errorData.message || `HTTP error! Status: ${response.status}`;
                throw new Error(errorMessage);
            }
 
            const data = await response.json();
 
            // navigate('/candidate/personal-info', { replace: true });
 
            if (data.success && data.data && data.data.url) {
                localStorage.setItem('client_id',data.data.client_id)
                window.location.href = data.data.url;
            }
            else {
                throw new Error(data.message || "Failed to get a redirection URL from the API.");
            }
 
        } catch (err) {
            console.error("DigiLocker API Error:", err);
            setError(err.message || 'An unexpected error occurred during verification.');
            setIsLoading(false);
            // navigate('/login', { replace: true });
 
        }
    }, []);
 
    return (
        <div className="digilockerrouter-container">
            <div className="digilockerrouter-card">
                <div className="digilockerrouter-header-icon-wrapper">
                    <ShieldIcon />
                </div>
               
                <h2 className="digilockerrouter-title">Document Verification</h2>
                <p className="digilockerrouter-subtitle">Securely access your documents through DigiLocker</p>
               
                {/* Features List remains the same */}
                <div className="digilockerrouter-features-list">
                    <div className="digilockerrouter-feature-item">
                        <InstantAccessIcon />
                        <div className="digilockerrouter-feature-text">
                            <h4 className="digilockerrouter-feature-title">Instant Access</h4>
                            <p className="digilockerrouter-feature-description">Get immediate access to your verified documents</p>
                        </div>
                    </div>
                   
                    <div className="digilockerrouter-feature-item">
                        <SecureTrustedIcon />
                        <div className="digilockerrouter-feature-text">
                            <h4 className="digilockerrouter-feature-title">Secure & Trusted</h4>
                            <p className="digilockerrouter-feature-description">Government-backed digital document platform</p>
                        </div>
                    </div>
                </div>
 
                <div className="digilockerrouter-ready-to-proceed">
                    <h3 className="digilockerrouter-ready-title">Ready to proceed?</h3>
                    <p className="digilockerrouter-ready-description">
                        Click the button below to securely connect with DigiLocker and access your documents
                    </p>
                </div>
 
                {/* Error Display */}
                {error && (
                    <div className="digilockerrouter-error-message" style={{ color: 'red', margin: '10px 0' }}>
                        Error: {error}
                    </div>
                )}
               
                <button
                    className="digilockerrouter-verify-button"
                    onClick={handleVerifyClick}
                    disabled={isLoading} // Disable button while loading
                >
                    {isLoading ? 'Redirecting...' : 'Verify with DigiLocker'}
                </button>
               
                <p className="digilockerrouter-footer-note">
                    By clicking above, you will be redirected to the official DigiLocker platform to authenticate and authorize document access
                </p>
            </div>
        </div>
    );
};
 
export default DigiLockerVerification;